import Http from '../../../../network/Http'
import {NatGetMaintenanceForResident} from './NatGetMaintenanceForResident';
import {NatPutMaintenanceForResident, NatPutMaintenanceSettingMasterParam} from './NatPutMaintenanceForResident';

export default class NatMaintenanceSettingMasterRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // メンテナンス設定マスタ(居住者)取得
    async getMaintenanceSettingMasterResident(): Promise<NatGetMaintenanceForResident> {
        return await this.http.get(`/api/admin/maintenance/resident`);
    }

    // メンテナンス設定マスタ(居住者)更新
    async putMaintenanceSettingMasterResident(request: NatPutMaintenanceSettingMasterParam):
        Promise<NatPutMaintenanceForResident> {
        return await this.http.put(`/api/admin/maintenance/resident`, request);
    }

}
